import React from "react";
import { Box, Container, Typography } from "@mui/material";
import { motion } from "framer-motion";
import DailySummaryMockup from "./DailySummaryMockup";
import { colors } from "../theme/tokens";

const mindfulPoints = [
  "Reduce mental clutter with simple organization",
  "Find focus with a calm, intentional design",
  "Maintain work-life balance with mindful scheduling",
];

const TodoShowcaseSection: React.FC = () => (
  <Box
    id="mindful"
    sx={{
      py: { xs: 8, md: 12 },
      px: { xs: 3, md: 6 },
      background: colors.primarySoft,
      borderTop: `1px solid ${colors.primaryTint}`,
      borderBottom: `1px solid ${colors.primaryTint}`,
      overflow: "hidden",
    }}
  >
    <Container
      maxWidth={false}
      sx={{
        maxWidth: "1120px",
        px: 0,
        display: "flex",
        gap: { xs: 6, md: 8 },
        alignItems: "center",
        flexWrap: "wrap",
      }}
    >
      <Box
        component={motion.div}
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.7 }}
        sx={{ flex: "1 1 440px", minWidth: 0 }}
      >
        <Typography
          component="h2"
          sx={{
            fontSize: { xs: "28px", md: "34px" },
            fontWeight: 800,
            letterSpacing: "-0.01em",
            color: colors.ink,
            m: 0,
            mb: 2.5,
          }}
        >
          Mindful{" "}
          <Box component="span" sx={{ color: colors.primary }}>
            task management
          </Box>
        </Typography>

        <Typography
          sx={{
            fontSize: "18px",
            color: colors.bodyStrong,
            lineHeight: 1.65,
            mb: 2,
          }}
        >
          Reduce cognitive load with a tool that works with your mind, not
          against it.
        </Typography>

        <Typography sx={{ color: colors.muted, lineHeight: 1.7, mb: 3.5 }}>
          Renoten offers a serene, distraction-free space designed for focused
          work. Capture tasks, complete them mindfully, and maintain mental
          clarity throughout your day.
        </Typography>

        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.75 }}>
          {mindfulPoints.map((point) => (
            <Box
              key={point}
              sx={{ display: "flex", alignItems: "center", gap: 1.25 }}
            >
              <Box
                component="span"
                sx={{
                  width: 20,
                  height: 20,
                  borderRadius: "50%",
                  background: colors.primary,
                  color: "#fff",
                  fontSize: "11px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                ✓
              </Box>
              <Typography sx={{ fontSize: "15px", color: colors.body }}>
                {point}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>

      <Box
        component={motion.div}
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.25 }}
        transition={{ duration: 0.8 }}
        sx={{
          flex: "1 1 420px",
          minWidth: 0,
          maxWidth: "480px",
          display: "flex",
          justifyContent: "center",
          width: "100%",
        }}
      >
        <DailySummaryMockup />
      </Box>
    </Container>
  </Box>
);

export default TodoShowcaseSection;
